import React, { Component } from 'react';
import styles from '../../../Assets/Styles/Components/Book/Packages/Modal.module.css';

class Modal extends Component {
    render() {
        const { modal } = this.props;
        const { title, features = [], duration, type, extensionPrices = [], flatExtensionPrice = 0 } = modal || {};
        const isFeatureModal = type === 'features' && features.length !== 0;
        const isExtensionPricesModal = type === 'extension_prices' && (extensionPrices.length !== 0 || flatExtensionPrice > 0);
        const isActive = isFeatureModal || isExtensionPricesModal;

        return (
            <div className={`${styles.mymodalContainer} ${isActive ? styles.active : ''}`} onClick={() => { this.props.onCloseModal(); }}>
                <div
                    className={`${styles.mymodal} ${isActive ? styles.active : ''}`}
                    onClick={(e) => { e.stopPropagation(); }}
                >
                    <div className={styles.header}>
                        <p> {title} {` [ بسته ${duration} ساعته ] `} </p>
                        <span
                            onClick={() => { this.props.onCloseModal(); }}
                            className={styles.closeMymodal}
                        >
                            &#10006;
                        </span>
                    </div>

                    {isFeatureModal && (
                        <div className={styles.text}>
                            <ul>
                                {
                                    features.map((i, index) => {
                                        return (
                                            <li key={`${title}-feature-${index}`}>
                                                <img src="" alt="" className={styles.icon} />
                                                <p> {i} </p>
                                            </li>);
                                    })
                                }
                            </ul>
                        </div>
                    )}

                    {isExtensionPricesModal && (
                        <div className={styles.text}>
                            <h5 className={styles.sectionTitle}>هزینه تمدید ساعت بیشتر</h5>
                            <table className={styles.extensionTable}>
                                <thead>
                                    <tr>
                                        {flatExtensionPrice <= 0 && <th>سطح</th>}
                                        <th>هر ۳۰ دقیقه اضافه</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {flatExtensionPrice > 0 ? (
                                        <tr>
                                            <td>{new Intl.NumberFormat().format(flatExtensionPrice)} تومان</td>
                                        </tr>
                                    ) : extensionPrices.map((item, index) => (
                                        <tr key={`${title}-extension-${index}`}>
                                            <th>{item.title}</th>
                                            <td>{new Intl.NumberFormat().format(Number(item.price))} تومان</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default Modal;
